import React from 'react';
import { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import AddRolesAndRights from './add-roles-and-rights';
import ManageRolesAndRights from './manage-roles-and-rights';
import { TypeAnimation } from 'react-type-animation';
const RolesAndRights = () => {
     const [key, setKey] = useState('add-roles-and-rights');
         const renderTabTitle = (tabKey, title) => {
        if (key === tabKey) {
            return (
                <span className="fixed-tab-title">
                    <TypeAnimation
                        sequence={[title]}
                        speed={40}
                        wrapper="span"
                        cursor={false}
                        repeat={0}
                        key={key}
                    />
                </span>
            );
        }
        return <span className="fixed-tab-title">{title}</span>;
    };
        return (
         <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}  
      unmountOnExit    
    >
      <Tab eventKey="add-roles-and-rights" title={renderTabTitle('add-roles-and-rights', 'Add Roles and Rights')} className='add-roles-and-rights'>
     <AddRolesAndRights />
      </Tab>
      <Tab eventKey="manage-rights-by-roles" title={renderTabTitle('manage-rights-by-roles', 'Manage Rights by Roles')} className='manage-roles-rights'>
      <ManageRolesAndRights />
      </Tab>

    </Tabs>
             );
};

export default RolesAndRights;